// extracted by mini-css-extract-plugin
export var amount = "HotelCard-module--amount--6a705";
export var contentContainer = "HotelCard-module--contentContainer--a50c9";
export var days = "HotelCard-module--days--65a96";
export var heading = "HotelCard-module--heading--a97d7";
export var hotel = "HotelCard-module--hotel--2e447";
export var hotelLink = "HotelCard-module--hotelLink--7577f";
export var link = "HotelCard-module--link--02990";
export var price = "HotelCard-module--price--9bb86";
export var save = "HotelCard-module--save--2802d";
export var star = "HotelCard-module--star--7b007";
export var subheading = "HotelCard-module--subheading--4d385";
export var was = "HotelCard-module--was--0130f";